import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import styles from "./TutorialPreview.module.css"
import Button from "../Button"
import Slider from "../Slider/Slider"
import BASE_URL from "../../config"
import { tutorialPreview } from "../../assets/dummyData"
import { resolveMediaUrl } from "../../utils/mediaUrl"

const TutorialPreview = () => {
    const [tutorials, setTutorials] = useState(null);
    const [status, setStatus] = useState('idle');
    const [visibleSlides, setVisibleSlides] = useState(3);
    const [hoveredIndex, setHoveredIndex] = useState(null);

    useEffect(() => {
        const loadTutorials = async () => {
            setStatus('loading');
            try {
                const res = await fetch(`${BASE_URL}/v1/tutorials/?page=1&page_size=100`);
                if (res.ok) {
                    const data = await res.json();
                    setTutorials(data);
                }
                setStatus('succeeded');
            } catch {
                setStatus('failed');
            }
        };
        loadTutorials();
    }, []);

    useEffect(() => {
        const updateVisibleSlides = () => {
            if (window.innerWidth < 760) {
                setVisibleSlides(1);
            } else if (window.innerWidth < 1450) {
                setVisibleSlides(2);
            } else {
                setVisibleSlides(3);
            }
        };
        updateVisibleSlides();
        window.addEventListener('resize', updateVisibleSlides);
        return () => window.removeEventListener('resize', updateVisibleSlides);
    }, []);

    const tutorialsData = tutorials?.data?.length ? tutorials.data : tutorialPreview;

    const items = tutorialsData.map((item, index) => (
        <article 
            key={item.id} 
            className={styles.tutorial}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
        >
            <Link to={`/tutorials/${item.slug}`} className={styles.tutorialLink}>
                <div className={`${styles.hoveredImage} ${hoveredIndex === index ? styles.visible : styles.hidden}`}>
                    <div className={styles.readMore}>
                        Read More
                        <svg
                            width="27"
                            height="36"
                            viewBox="0 0 27 36"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M16.707 11.9908L22.364 17.6478C22.5515 17.8354 22.6568 18.0897 22.6568 18.3548C22.6568 18.62 22.5515 18.8743 22.364 19.0618L16.707 24.7188C16.5184 24.901 16.2658 25.0018 16.0036 24.9995C15.7414 24.9972 15.4906 24.8921 15.3052 24.7067C15.1198 24.5212 15.0146 24.2704 15.0123 24.0082C15.01 23.746 15.1108 23.4934 15.293 23.3048L19.243 19.3548L6 19.3548C5.73478 19.3548 5.48043 19.2495 5.29289 19.0619C5.10536 18.8744 5 18.6201 5 18.3548C5 18.0896 5.10536 17.8353 5.29289 17.6477C5.48043 17.4602 5.73478 17.3548 6 17.3548L19.243 17.3548L15.293 13.4048C15.1975 13.3126 15.1213 13.2022 15.0689 13.0802C15.0165 12.9582 14.9889 12.827 14.9877 12.6942C14.9866 12.5615 15.0119 12.4298 15.0622 12.3069C15.1125 12.184 15.1867 12.0723 15.2806 11.9784C15.3745 11.8845 15.4861 11.8103 15.609 11.76C15.7319 11.7097 15.8636 11.6844 15.9964 11.6856C16.1292 11.6867 16.2604 11.7143 16.3824 11.7667C16.5044 11.8191 16.6148 11.8953 16.707 11.9908Z" />
                        </svg>
                    </div>
                </div>
                <div className={styles.tutorialImg}>
                    <img src={resolveMediaUrl(item.cover) || item.image} alt={item.title} />
                </div>
            </Link>
            <h3 className={`h3-medium ${styles.tutorialTitle}`}>{item.title}</h3>
            <p className={`h5-light ${styles.tutorialText}`}>{item.short_description || item.text}</p>
        </article>
    ));

    return (
        <section className={`height ${styles.main}`}>
            <h2 className="h2-bold">Tutorials</h2>
            {status === "loading" && !tutorials?.data ? (
                <div className={styles.container}>
                    {tutorialPreview.map((item) => (
                        <article key={item.id} className={styles.tutorial}>
                            <div className={styles.topCont}>
                                <div className={styles.readmorebtn}>
                                    <Button variant="outline-blue" label="Read more" iconType="arrowRight"/>
                                </div>
                                <div className={styles.tutorialImg}>
                                    <img src={item.image} alt={item.title} />
                                </div>
                            </div>
                            <div className={styles.title}>
                                <h3 className="h3-medium">{item.title}</h3>
                            </div>
                            <p className="h5-light">{item.text}</p>
                        </article>
                    ))}
                </div>
            ) : (
                <Slider items={items} visibleSlides={visibleSlides} />
            )}
            <div className={styles.btn}>
                <Link to="/tutorials">
                    <Button
                        variant="blue"
                        label="Browse all"
                        iconType="arrowRight"
                    />
                </Link>
            </div>
        </section>
    );
}

export default TutorialPreview
